import React from 'react';
import { useContent } from '../lib/ContentContext';
import { PageHero } from '../components/site/PageHero';
import { SectionHeading } from '../components/site/SectionHeading';
import { ProductTable } from '../components/site/ProductTable';

/**
 * Generic industry product-table page for Leather / Paper / Paints & Coatings.
 * contentKey: leather_page | paper_page | paints_page
 */
export default function IndustryProducts({ contentKey }) {
  const { content } = useContent();
  const page = content?.[contentKey];
  if (!page) return null;

  return (
    <div>
      <PageHero title={page.hero_title} subtitle={page.hero_subtitle} image={page.hero_image} />
      <section className="py-14 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <SectionHeading className="mb-6">{page.section_title}</SectionHeading>
          {page.intro && (
            <div className="mb-10 w-full space-y-4" data-testid="industry-page-intro">
              {(Array.isArray(page.intro) ? page.intro : [page.intro]).map((p, i) => (
                <p
                  key={i}
                  className="cms-html w-full text-justify text-black/80 leading-8"
                  dangerouslySetInnerHTML={{ __html: p }}
                />
              ))}
            </div>
          )}
          <ProductTable columns={page.columns} rows={page.rows} />
        </div>
      </section>
    </div>
  );
}
